type Props = {
    text: string;
};

export const LeavingModalContent = ({ text }: Props) => {
    return <div className="leavingModalContent">{text}</div>;
};
